import { defineMessages } from 'react-intl';

const messages = defineMessages({
  //overview
  Trainings: 'Trainings',
  TrainingsManagement: 'TrainingsManagement',
  Name: 'Name',
  Type: 'Type',
  Resource: 'Resource',
  Status: 'Status',
  ExpectedTrainingHours: 'Expected training hours',
  Hours: 'Hours',
  StartDate: 'Start date',
  EndDate: 'End date',
  Mandatory: 'Mandatory',
  CertificateRequired: 'Certificate required',
  Description: 'Description',
  NoDataFound: 'NoDataFound',
  Actions: 'Actions',
  Delete: 'Delete',
  DeleteTraining: 'Delete training',
  DeleteTrainingConfirmationMsg: 'Are you sure you want to delete this training?',
  EditTraining: 'Edit training',
  AddUsers: 'Add users',
  //add training
  What: 'What',
  AddTraining: 'Add training',
  TrainingCreated: 'Training created',
  CreateTraining: 'Create training',
  TrainingUpdated: 'Training updated',
  SearchPriceListItem: 'Search price list item',
  NoPriceListItemsFound: 'No price list items found',
  //trainingEmployees
  MarkAsComplete: 'Mark as complete',
  CancelEmployee: 'Cancel employee training',
  RegisterEmployee: 'Register employee',
  NoEmployeesRegistered: 'No employees registered yet',
  Teams: 'Teams',
  RegisteredTrainingHours: 'Registered training hours',
  NoTrainingsFound: 'No trainings found',
  Available: 'Registered Available',
  Completed: 'Completed',
  ReopenTrainingEmployee: 'Reopen training',
  PlanTrainingForSelectedEmployees: 'Plan training for selected employees',
  RegisteredHours: 'Registered hours',
  OwnCompany: 'Own company',
  SearchEmployees: 'Search employees',
  EmployeeType: 'Employee type',
  WithEmployeeTags: 'With employee tags',
  AllRoles: 'AllRoles',
  //trainingEmployeesOverview
  AddRegistration: 'Add registration',
  TrainingClosed: 'Training closed',
  TrainingCancelled: 'Training cancelled',
  CompletedDate: 'Completed date',
  OpenTrainingDetails: 'Open training details',
  OpenRegistrationOverview: 'Open registration overview',
  //filters
  ResetFilters: 'Reset filters',
  //EmployeeTraining
  Training: 'Training',
  Close: 'Close',
  //documents
  Documents: 'Documents',
  UploadDocument: 'Upload document',
  DeleteDocument: 'Delete document',
  ConfirmDeleteDocument: 'Are you sure you want to delete this document?',
  ConfirmDeleteDocumentTitle: 'Delete?',
  CertificateOfTraining: 'Certificate of training',
  CertificateMissing: 'Certificate is missing',
  Progress: 'Progress',
  EndDatePassed: 'End date has passed',
  EndDateApproaching: 'End date is approaching',
  //exports
  Export: 'Export',
  ExportToExcelStarted: 'Export to Excel started',
  ExportTrainingAssignments: 'Export training assignments',
  ExportTrainingTimeRegistrations: 'Export training time registrations',
});

export default messages;
